var _style;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLoadingSpinner = props => /*#__PURE__*/React.createElement("svg", _extends({
  id: "icon",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, "@keyframes spin-animation{0%{transform:rotate(0deg)}to{transform:rotate(360deg)}}@keyframes spring{0%{stroke-dashoffset:.2}50%{stroke-dashoffset:.8}}")), /*#__PURE__*/React.createElement("circle", {
  cx: 12,
  cy: 12,
  r: 10.8,
  strokeWidth: 2.4,
  stroke: "currentColor",
  fill: "none",
  pathLength: 1,
  strokeLinecap: "round",
  style: {
    transformOrigin: "center center",
    animation: "spin-animation linear infinite .8s,spring cubic-bezier(.46,.03,.52,.96) infinite 2s"
  },
  strokeDasharray: 1,
  strokeDashoffset: 0.2
}));
export { SvgLoadingSpinner as ReactComponent };
export default __webpack_public_path__ + "4c2b5afb86d431049123869695db74ed15ffa67334a01a100e5d762c14b987ce.svg";